import {ErrorState} from "../context/ErrorContext";

type Props = {
    error: ErrorState
}

const Error = ({error}: Props) =>  {
    if (!error) {
        return (<>xDDD</>)
    }

    if (error.status === 404) {
        error.message = 'Page not found'
    }

    return (
        <section>
            <div className='row justify-content-center align-content-center w-100 h-100 top-0 position-absolute' style={{zIndex: '-5'}}>
                <div className='col-md-6'>
                    <h1>{error.status} - error</h1>
                    <h2>{error.message}</h2>
                </div>
            </div>
        </section>
    )
}

export default Error;
